<template>
  <nav class="side-menu">
    <ul class="side-menu-list">
      <sidebar-administration v-if="adminUrl"></sidebar-administration>    
      <sidebar-search></sidebar-search>
      <sidebar-portal></sidebar-portal>
      <sidebar-person></sidebar-person>
      <sidebar-basket></sidebar-basket>
    </ul>
  </nav>
</template>

<script>
  import SidebarBasket from "./SidebarBasket";
  import SidebarPerson from "./SidebarPerson";
  import SidebarPortal from "./SidebarPortal";
  import SidebarSearch from "./SidebarSearch";
  import SidebarAdministration from "./SidebarAdministration";

  export default {
    vuex: {
      getters: {
        adminUrl: state => state.menu.AdminUrl
      }
    },
    components: { SidebarBasket, SidebarPerson, SidebarPortal, SidebarSearch, SidebarAdministration }
  };
</script>

<style lang="scss">
  @import '../../../assets/scss/variables.scss';
  @import '../../../assets/scss/mixins.scss';
  @import '../../../assets/scss/devices.scss';
  
  .side-menu{
    position: absolute;
    top: 0;
    right: 0;
    text-align: center;

    .transparent &:before{
      content: "";
      background: url(../../../assets/img/logo-shadow-right.png) no-repeat;
      position: absolute;
      top: 0px;
      right: 0px;
      width: 303px;
      height: 70px;
      background-size: cover;
      z-index: 0;
    }
  }

  .side-menu-closer{
    position: absolute;
    top: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background: transparent;
    display: block;
    z-index: -2;
  }

  .side-menu-list{
    @include clear-fix;
    display: block;
    list-style: none;
    margin: 0px auto;
    padding: 19px 28px 20px;
    position: relative;
    text-align: left;
    z-index: 1;
    background: #ffffff;

    .transparent &{
      background: transparent;
    }
    
    &__item{
      display: inline-block;
      margin-left: 15px;
      &:first-child{
        margin-left: 0;
      }
    }

    @include min-screen(1200px){
      &__item{
        margin-left: 33px;
      }
    }

    &__icon{
      position: relative;
      display: inline-block;
      width: 32px;
      height: 32px;
      vertical-align: middle;
      z-index: 100;

      &.icon--disabled{
        opacity: 0.25;
      }
    }
  }

  .sidebar{
    position: absolute;
    top: 70px;
    right: 0;
    width: 400px;
    background: #fff;
    z-index: -1;
    padding: 0px 50px 50px;
    box-sizing: border-box;
    border: 1px solid $green_light;
    border-top: none;

    &__block{
      margin-bottom: 40px;
      &:last-child{ margin-bottom: 0; }
    }

    &__value{
      margin: 0;
      opacity: 0.6;
      .transparent &{
        color: $green_light;
        opacity: 1;  
      }
    }

    &__title{
      margin: 0 0 5px;
    }

    .transparent &{
      background: rgba(1,1,1,0.7);
      color: #ffffff;
      border: 0px;
      position: absolute;
      top: 0px;
      padding-top: 71px;
    }
  }

</style>



// WEBPACK FOOTER //
// Sidebar.vue?bc057248